module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/webinar-sketch.json
// module id = 2117
// module chunks = 175659006645051